export default __webpack_public_path__ + "static/media/Scoriaceous Cache of Oblivion.79fcb0f6.jpg";